import EulaText from "../components/EulaText";

export default function EULA() {
    return (
        <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column', padding: 16}}>
            <EulaText />
        </div>
    )
}